"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.XHRRefreshSessionPlugin = void 0;
const constants_1 = require("../../../xhr/constants");
const XHRResponse_1 = require("../../../xhr/XHRResponse");
/**
 *
 * @deprecated please use from web-ui-security instead
 * @link https://github.com/santander-group-ods/SOFTWEB-web-ui-security | web-ui-security
 *
 */
class XHRRefreshSessionPlugin {
    constructor(session, xhrRequestsBlocker) {
        this.name = this.constructor.name;
        this.session = session;
        this.xhrRequestsBlocker = xhrRequestsBlocker;
    }
    refreshSession() {
        return __awaiter(this, void 0, void 0, function* () {
            this.xhrRequestsBlocker.startBlockingRequests();
            if (!this.refreshSessionPromise) {
                this.refreshSessionPromise = new Promise((resolve, reject) => {
                    (() => __awaiter(this, void 0, void 0, function* () {
                        try {
                            yield this.session.refresh();
                            this.refreshSessionPromise = undefined;
                            resolve();
                        }
                        catch (e) {
                            reject(e);
                        }
                    }))();
                });
            }
            yield this.refreshSessionPromise;
            this.xhrRequestsBlocker.finishBlockingRequest();
        });
    }
    reCallOrigin(xhrResponse) {
        return __awaiter(this, void 0, void 0, function* () {
            const originCallResponse = yield xhrResponse.calls.fetchCall();
            return XHRResponse_1.XHRResponse.create(originCallResponse, xhrResponse.params, xhrResponse.calls);
        });
    }
    handleResponse(xhrResponse) {
        return __awaiter(this, void 0, void 0, function* () {
            const httpStatus = xhrResponse.data.httpStatus;
            if (httpStatus === constants_1.HTTP_STATUS.UNAUTHORIZED) {
                try {
                    yield this.refreshSession();
                    return Promise.resolve(yield this.reCallOrigin(xhrResponse));
                }
                catch (e) {
                    return Promise.reject(e);
                }
            }
            return Promise.resolve(xhrResponse);
        });
    }
}
exports.XHRRefreshSessionPlugin = XHRRefreshSessionPlugin;
//# sourceMappingURL=xhrRefreshSessionPlugin.js.map